import { CostSalesFormValues } from '@/core/domain/workorder/ManagementCharts/ManagementChart.types';
import { Form, Modal, ModalProps } from 'antd';
import React from 'react';
import SalesCostXSaleForm from './SalesCostXSaleForm';

type Props = Omit<ModalProps, 'onOk'> & {
  handleOk: (values: CostSalesFormValues) => void;
};

const SalesCostXSaleModal: React.FC<Props> = ({ open, onCancel, handleOk }) => {
  const [form] = Form.useForm<CostSalesFormValues>();

  return (
    <Modal
      title="Custo x Venda (Peças)"
      open={open}
      onCancel={onCancel}
      width={600}
      okText="Atualizar Gráfico"
      onOk={async () => {
        try {
          const values = await form.validateFields();
          handleOk({
            ...values,
            startDate: values?.startDate.startOf('day'),
            endDate: values?.endDate.endOf('day'),
          });
        } catch {}
      }}
    >
      <SalesCostXSaleForm form={form} />
    </Modal>
  );
};

export default SalesCostXSaleModal;
